var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h6',{staticClass:"mb-3"},[_vm._v(_vm._s(this.label))]),_c('PieChart',{attrs:{"chart-data":_vm.chartData},on:{"rowClick":_vm.handleClick,"chartClick":_vm.handleClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }